/**
 * Update date: 15-05-2023
 * Screen 1044.2
 */
import { DataGridFull } from 'app/components/DataGrid';
import PopupConfirmDelete from 'app/components/PopupCommon/PopupConfirmDelete';
import useAxios from 'axios-hooks';
import LoadPanel from 'app/components/LoadPanel';
import moment from 'moment';
import React, { forwardRef, useState } from 'react';
import { notification } from 'utils/notification';
import { useRegisteringStore } from '..';
import FormSearch from '../FormSearch';
import { useApp } from 'app';
import { BreadCrumbPremium } from 'app/components/BreadCrumbPremium';

const exportFileName =
  'SMDC_1044.2 Registering Store_' + moment().format('YYYYMMDD');

function ListStore(props, ref) {
  const { themePro }: any = useApp();
  const context: any = useRegisteringStore();
  const { setModeView, store, t } = context;
  const [showModalDelete, setShowModalDelete] = useState(false);

  const selectedKeys = ref?.current?.instance?.option().selectedRowKeys;
  const [{ loading: loadingDelete }, refetchDelete] = useAxios(
    {
      url: 'user/store',
      method: 'DELETE',
    },
    { manual: true, autoCancel: true },
  );

  /**
   * on delete
   *
   * @return {*} 
   */
  const onDelete = async () => {
    if (!selectedKeys?.length) return;
    const res = await refetchDelete({
      data: {
        ids: selectedKeys,
      },
    });

    notification({
      res,
    });
    if (res?.data?.status === '200') {
      selectedKeys?.forEach(storeNo => {
        store
          .remove(storeNo)
          .done(() => {})
          .fail(() => {});
      });
      deselectAll();
      setShowModalDelete(false);
    }
  };

  /**
   * deselect all
   *
   */
  const deselectAll = () => {
    ref?.current?.instance?.deselectAll();
  };

  /**
   * render store
   *
   * @param {*} record
   * @return {*} 
   */
  const renderStore = record => {
    const { storeNo, storeNm } = record?.data || {};
    return (
      <div
        onClick={() => {
          setModeView({ type: 'edit', storeNo });
        }}
        className="cell-link"
      >
        {storeNm}
      </div>
    );
  };
  /**
   * export excel
   *
   */
  const exportExcel = () => {
    ref?.current?.instance?.exportToExcel();
  };
  return (
    <>
      <LoadPanel visible={loadingDelete} />
      <BreadCrumbPremium />
      <FormSearch />
      <DataGridFull
        ref={ref}
        dataSource={store}
        fixedRight={1}
        columns={[
          {
            dataField: 'storeNo',
            caption: t('ID'),
            alignment: 'left',
          },
          {
            dataField: 'storeCd',
            caption: t('Store Code'),
            alignment: 'left',
          },
          {
            dataField: 'storeTpName',
            caption: t('Type'),
          },
          {
            dataField: 'storeNm',
            caption: t('Store'),
            cellRender: renderStore,
          },
          {
            dataField: 'bussinessNumber',
            caption: t('Business Number'),
          },
          {
            dataField: 'unitPrice',
            caption: t('Supply Unit Price Group'),
          },
          {
            dataField: 'representative',
            caption: t('Representative'),
          },
          {
            dataField: 'mobile',
            caption: t('Mobile No'),
          },
          {
            dataField: 'phone',
            caption: t('Phone No'),
          },
          {
            dataField: 'onlineApprovalTf',
            caption: t('AOS Card Payment'),
            alignment: 'center',
            editorType: 'dxSwitch',
          },
          {
            dataField: 'shippingTrackingTf',
            caption: t('Shipping Tracking'),
            alignment: 'center',
            editorType: 'dxSwitch',
          },
          {
            dataField: 'useflag',
            caption: t('Use'),
            alignment: 'center',
            editorType: 'dxSwitch',
            trueText: t('Use'),
            falseText: t('Not Use'),
          },
        ]}
        storageKey="1044.2"
        options={{
          key: 'storeNo',
          columnAutoWidth: true,
          // height: '70vh',
          onToolbarPreparing: (e: any) => {
            e.toolbarOptions.items.unshift(
              {
                location: 'before',
                template: 'totalCount',
              },
              {
                location: themePro ? 'after' : 'before',
                widget: 'dxButton',
                options: {
                  icon: 'add',
                  text: t('Create New'),
                  onClick: () => setModeView({ type: 'create' }),
                },
              },
              {
                location: themePro ? 'after' : 'before',
                widget: 'dxButton',
                options: {
                  icon: 'trash',
                  text: t('Delete'),
                  // disabled: !selectedKeys?.length,
                  onClick: () => setShowModalDelete(!showModalDelete),
                },
              },
              {
                location: themePro ? 'before' : 'before',
                widget: 'dxButton',
                options: {
                  icon: 'xlsxfile',
                  text: t('Export to Excel'),
                  onClick: () => exportExcel(),
                },
              },
            );
          },
          export: {
            fileName: exportFileName,
          },
          selection: {
            mode: 'multiple',
            selectAllMode: 'allPages',
            showCheckBoxesMode: 'onClick',
          },
        }}
      />
      <PopupConfirmDelete
        visible={showModalDelete}
        content={`${t('Do you want to delete {0} items?')}`.replace(
          '{0}',
          selectedKeys?.length,
        )}
        onOk={onDelete}
        onHiding={() => setShowModalDelete(!showModalDelete)}
      />
    </>
  );
}

export default forwardRef(ListStore);
